import appFooter from '../../components/footer/footer'

export default {
    name: 'privacy',
    components: {
        appFooter
    }
}
